import { FilterableMailBoxUrlSlugs } from '@ukpostbox/client-data';
import { GetArrayIndexByKeyValue } from '@ukpostbox/helpers';
import { FormatIsoDateTime } from '@ukpostbox/helpers/lib/Date';
import { enGB } from 'date-fns/locale';
import { Location } from 'react-router';
import { GenericUrlSlugsType } from '../Types/UtilsTypes';
import { MailboxUrlParamsType } from '../../Mailboxes/Types/MailboxUtilsTypes';

const BuildUrlFilterFromParams = (
	props: MailboxUrlParamsType,
	location: Location,
	name: string,
	data?: any,
	isArray?: boolean,
	overrideValue?: any,
): GenericUrlSlugsType => {
	const newValue = location.state && location.state[name] !== undefined ? location.state[name] : (props as any)[name];
	const friendlyValue =
		location.state && location.state[`${name}Friendly`] ? location.state[`${name}Friendly`] : undefined;

	if (newValue === null || newValue === undefined) {
		return {};
	}

	return {
		[name]: {
			value: overrideValue || (isArray ? [newValue] : newValue),
			friendlyValue:
				friendlyValue || (data ? data[GetArrayIndexByKeyValue(data, 'value', newValue)].label : null),
		},
	};
};

const UpdateAllFilters = (existingFilters: FilterableMailBoxUrlSlugs): FilterableMailBoxUrlSlugs => {
	const newFilters = JSON.parse(JSON.stringify(existingFilters));

	if (newFilters.startDate?.value) {
		newFilters.startDate.value = FormatIsoDateTime(newFilters.startDate.value as Date, enGB);
	}

	if (newFilters.endDate?.value) {
		newFilters.endDate.value = FormatIsoDateTime(newFilters.endDate.value as Date, enGB);
	}

	return newFilters;
};

const DeleteFilter = (
	existingFilters: FilterableMailBoxUrlSlugs,
	filterName: keyof GenericUrlSlugsType,
): FilterableMailBoxUrlSlugs => {
	const newFilters: FilterableMailBoxUrlSlugs = JSON.parse(JSON.stringify(existingFilters));

	// @ts-ignore
	delete newFilters[filterName];

	return newFilters;
};

export { BuildUrlFilterFromParams, DeleteFilter, UpdateAllFilters };
